/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type special_allocations_CreateAbsenceRequest = {
    /**
     * ChildID references the child for this absence (required)
     */
    child_id: string;
    /**
     * ClientCaptureID is an OPTIONAL idempotency key (#1916): 1-255 printable ASCII. A repeat
     * with the same key and body by the same user returns the absence the first call created
     * (200, Idempotent-Replayed: true); the same key with another body answers 409
     * IDEMPOTENCY_CONFLICT. The employee app's offline queue stamps its row id here.
     */
    client_capture_id?: string;
    /**
     * Comment optional additional information about the absence (max 500 characters)
     */
    comment?: string;
    /**
     * FromDatetime when the absence begins (required). Send a plain RFC3339
     * date-time string, or a date-only string ("2006-01-02").
     * example: "2024-01-15T09:00:00Z"
     */
    from_datetime: string;
    /**
     * FullDay indicates if this is a full-day absence (required, default false)
     */
    full_day?: boolean;
    /**
     * Reason for the absence (required, one of: ILLNESS, VACATION, OTHER, UNKNOWN)
     */
    reason: special_allocations_CreateAbsenceRequest.reason;
    /**
     * ToDatetime when the absence ends (required). Send a plain RFC3339
     * date-time string, or a date-only string ("2006-01-02").
     * example: "2024-01-15T17:00:00Z"
     */
    to_datetime: string;
};
export namespace special_allocations_CreateAbsenceRequest {
    /**
     * Reason for the absence (required, one of: ILLNESS, VACATION, OTHER, UNKNOWN)
     */
    export enum reason {
        ILLNESS = 'ILLNESS',
        VACATION = 'VACATION',
        OTHER = 'OTHER',
        UNKNOWN = 'UNKNOWN',
    }
}

